export default __webpack_public_path__ + "static/media/email.a5358ada.svg";